import Loader from "components/Spinners/Loader";
import heart from "assets/icons/heart.svg";
import heartwhite from "assets/icons/heartwhite.svg";

export const FavoriteButton = ({ user, saddle, favouriteList, favouriteLoading, handleFavourite }) => (
  <div
    onClick={() => user && handleFavourite(saddle, favouriteList)}
    className={`heartBtn_cards_container !w-[40px] !h-[40px] ${
      !user ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
    } ${favouriteList?.includes(saddle?.sk) && "!bg-[#2B364B]"}`}
  >
    {favouriteLoading ? (
      <Loader
        filledColor="#2b364b"
        loaderStyles="!w-5 !h-5 !flex !items-center !text-center !justify-center"
      />
    ) : favouriteList?.includes(saddle?.sk) ? (
      <img src={heartwhite} alt="heart-white" />
    ) : (
      <img src={heart} alt="heart" />
    )}
  </div>
);

